import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-my-3.5 divide-y divide-[#eef0f3]"
}
const _hoisted_2 = {
  key: 1,
  class: "m-0 text-sm text-gray-600"
}

import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy } from '@/config/fulfillmentWizardSteps'


export default {
  __name: 'StepStores',
  props: { stores: { type: Array, default: () => [] } },
  setup(__props) {


const wizard = injectWizard()

const storeSubtitle = store => {
  const count = store.relationships?.products?.data?.length
  const status = store.attributes.status === 'live' ? 'Active' : 'Private'
  return count === undefined ? status : `${status} · ${count} product${count === 1 ? '' : 's'}`
}

const toggle = store => {
  const id = String(store.id)
  const ids = wizard.data.storeIds
  wizard.data.storeIds = ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('stores', _unref(wizard).data))), {
    default: _withCtx(() => [
      (__props.stores.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stores, (store) => {
              return (_openBlock(), _createBlock(ToggleRow, {
                key: store.id,
                title: store.attributes.store_name,
                description: storeSubtitle(store),
                "model-value": _unref(wizard).data.storeIds.includes(String(store.id)),
                "onUpdate:modelValue": $event => (toggle(store))
              }, null, 8, ["title", "description", "model-value", "onUpdate:modelValue"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, "Create a store first, then come back to add a fulfillment method."))
    ]),
    _: 1
  }, 16))
}
}

}